<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>监管单位</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">监管单位列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm2">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="所属省" prop="val1">
                  <el-select
                    v-model="ruleForm2.val1"
                    placeholder="请选择"
                    style="margin-right: auto; width: 150px"
                    @change="newcityChange"
                  >
                    <el-option
                      v-for="(item, index) in newCity"
                      :key="item.areaCode"
                      :label="item.name"
                      :value="item.areaCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="所属市"
                  prop="val2"
                  style="margin-left: 20px"
                >
                  <el-select
                    v-model="ruleForm2.val2"
                    placeholder="请选择"
                    style="margin-right: auto; width: 150px"
                    @change="newcityChange1"
                  >
                    <el-option
                      v-for="(item, index) in newCity1"
                      :key="item.areaCode"
                      :label="item.name"
                      :value="item.areaCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="所属区"
                  prop="val3"
                  style="margin-right: 20px"
                >
                  <el-select
                    v-model="ruleForm2.val3"
                    placeholder="请选择"
                    style="margin-right: auto; width: 150px"
                    @change="newcityChange2"
                  >
                    <el-option
                      v-for="(item, index) in newCity2"
                      :key="item.areaCode"
                      :label="item.name"
                      :value="item.areaCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="所属街道"
                  prop="val4"
                  style="margin-right: 30px"
                >
                  <el-select
                    v-model="ruleForm2.val4"
                    placeholder="请选择"
                    style="margin-right: auto; width: 150px"
                    @change="getorgList1"
                  >
                    <el-option
                      v-for="(item, index) in newCity3"
                      :key="item.areaCode"
                      :label="item.name"
                      :value="item.areaCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="监管单位"
                  prop="val5"
                  style="margin-right: 30px"
                >
                  <el-select
                    v-model="ruleForm2.val5"
                    placeholder="请选择"
                    style="margin-right: auto; width: 150px"
                  >
                    <el-option
                      v-for="(item, index) in orgList1"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="getorgList('new')"
                    class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-table ref="scrollTable" :data="orgList" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="province" label="所属省" align="center">
          </el-table-column>
          <el-table-column prop="city" label="所属市" align="center">
          </el-table-column>
          <el-table-column prop="area" label="所属区" align="center">
          </el-table-column>
          <el-table-column prop="streetName" label="所属街道" align="center">
          </el-table-column>
          <el-table-column prop="name" label="监管单位" align="center">
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.askariData(),
      page: 1,
      pageSize: 10,
      total: 0,
      newCity: [],
      newCity1: [],
      newCity2: [],
      newCity3: [],
      areaCode: "",
      levelCode: 1,
      orgList: [],
      orgList1: [],
      ruleForm2: {
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        val5: "",
      },
    };
  },
  mounted() {
    this.getcityList();
    this.getorgList();
  },
  methods: {
    newcityChange() {
      this.levelCode = 2;
      this.areaCode = this.ruleForm2.val1;
      this.ruleForm2.val2 = "";
      this.ruleForm2.val3 = "";
      this.ruleForm2.val4 = "";
      this.ruleForm2.val5 = "";
      this.getcityList();
      this.getorgList1();
    },
    newcityChange1() {
      this.levelCode = 3;
      this.areaCode = this.ruleForm2.val2;
      this.ruleForm2.val3 = "";
      this.ruleForm2.val4 = "";
      this.ruleForm2.val5 = "";
      this.getcityList();
      this.getorgList1();
    },
    newcityChange2() {
      this.levelCode = 4;
      this.areaCode = this.ruleForm2.val3;
      this.ruleForm2.val4 = "";
      this.ruleForm2.val5 = "";
      this.getcityList();
      this.getorgList1();
    },
    getcityList() {
      let param = {
        areaCode: this.areaCode,
        levelCode: this.levelCode,
      };
      this.$axios
        .post(`/admapi/district/list`, param)
        .then(({ data }) => {
          if (this.levelCode == 1) {
            this.newCity = data;
          } else if (this.levelCode == 2) {
            this.newCity1 = data;
          } else if (this.levelCode == 3) {
            this.newCity2 = data;
          } else if (this.levelCode == 4) {
            this.newCity3 = data;
          }
        })
        .catch()
        .finally();
    },
    getorgList1() {
      let param = {
        provinceCode: this.ruleForm2.val1,
        cityCode: this.ruleForm2.val2,
        areaCode: this.ruleForm2.val3,
        streetCode: this.ruleForm2.val4,
      };
      this.$axios
        .post(`/admapi/sys/org/list`, param)
        .then(({ data }) => {
          this.orgList1 = data;
        })
        .catch()
        .finally();
    },
    getorgList(val) {
      if (val == "new") {
        this.page = 1;
      }
      let param = {
        provinceCode: this.ruleForm2.val1,
        cityCode: this.ruleForm2.val2,
        areaCode: this.ruleForm2.val3,
        streetCode: this.ruleForm2.val4,
        name: this.ruleForm2.val5,
        page: this.page,
        pageSize: this.pageSize,
      };
      this.$axios
        .post(`/admapi/sys/org/page`, param)
        .then(({ data }) => {
          this.orgList = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    resetForm() {
      this.ruleForm2.val1 = "";
      this.ruleForm2.val2 = "";
      this.ruleForm2.val3 = "";
      this.ruleForm2.val4 = "";
      this.ruleForm2.val5 = "";
      this.getorgList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getorgList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getorgList();
    },
  },
};
</script>
<style scoped></style>
